import React, { useEffect, useState } from "react"

import './styles.css';
import dayjs from 'dayjs';
import moment from 'moment';
import DefaultTextBold from "../../../../../components/Accessibility/DefaultTextBold";
import DefaultText from "../../../../../components/Accessibility/DefaultText";
import { usePrimeiroAgendamentoContext } from "../../contexts/PrimeiroAgendamentoContext";
import { AgendarAtendimentoFormik } from "../../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/AgendarAtendimentoFormik";
import { FormikProps } from "formik";
import { Horario } from "../../../../../interfaces/entities/SaudeBemEstar/Agendamento/Horario";
import { getHorariosDisponiveisPeriodoAdesao } from "../../../../../services/SaudeBemEstar/PrimeiroAgendamentoService";
import Calendar from "../../../../../components/Calendar/Calendar";
import WhiteContainer from "../../../../../components/Accessibility/WhiteContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { useMediaQuery } from "@mui/material";
import { sxBoxChevron, sxLabel } from "./sxProps";
import TypographyAccessibility from "../../../../../components/Accessibility/TypographyAccessibility";
import { HoursForm } from "./HoursForm";
import { IHorarioDisponivel } from "../../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/HorarioDisponivel";
import ButtonAccessibility from "../../../../../components/Accessibility/ButtonAccessibility";
import LoadingApp from "../../../../../components/LoadingApp";

interface DataHorarioFormProps {
  formik: FormikProps<AgendarAtendimentoFormik>
}

export const DataHorarioForm: React.FC<DataHorarioFormProps> = ({ formik }: DataHorarioFormProps) => {
  const { setTabs } = usePrimeiroAgendamentoContext();
  const [availableDates, setAvailableDates] = useState<Horario[]>([]);
  const [availableTimes, setAvailableTimes] = useState<IHorarioDisponivel[]>([]);
  const [selectedTime, setSelectedTime] = useState<IHorarioDisponivel | null>(formik.values.selectedHour);
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    formik.values.selectedDate
  );
  const [loading, setLoading] = useState<boolean>(false)

  const isMobile = useMediaQuery("(max-width: 1400px)");

  const handleSelectedDate = (date: Date) => {
    setSelectedDate(date);
  };

  const handleHour = (hour: IHorarioDisponivel) => {
    setSelectedTime(hour);
  }

  const handleSelectedMonth = (date: Date) => {
    setLoading(true)
    const month = date.getMonth();
    const startDate = moment(dayjs().month(month).startOf("month").toISOString()).format("DD/MM/YYYY");
    const endDate = moment(dayjs().month(month).endOf("month").toISOString()).format("DD/MM/YYYY");

    getHorariosDisponiveisPeriodoAdesao({
      dtInicial: startDate,
      dtFinal: endDate,
      tipoAtend: formik.values.tipoAtend,
    }).then((result) => {
      setAvailableDates(result);
      setAvailableTimes(result);
    }).finally(() => setLoading(false))
  };

  useEffect(() => {
    if (!selectedDate || dayjs(selectedDate).isSame(dayjs(), 'month')) {
      handleSelectedMonth(new Date());
    }
  }, [selectedDate]);

  return (
    <div className='page-container'>
      <LoadingApp showLoading={loading} text={'Carregando...'} />
      <div className="flex-col gap-16">
        <DefaultTextBold text="Data e Horário" />
        <DefaultText text="Selecione uma data e horário para seu atendimento:" />
      </div>
      <div className="page-content">
        <div>
          <TypographyAccessibility sx={sxLabel} >
            Selecione uma data no calendário
          </TypographyAccessibility>
          <Calendar
            handleDate={handleSelectedDate}
            handleMonth={handleSelectedMonth}
            daysList={availableDates.map((time) => time.data)}
            selectedDate={selectedDate} />
        </div>
        {
          selectedDate !== null &&
          <>
            {!isMobile &&
              <div className="content-chevron">
                <WhiteContainer shadow sx={sxBoxChevron}>
                  <FontAwesomeIcon icon={faChevronRight} />
                  <FontAwesomeIcon icon={faChevronRight} />
                </WhiteContainer>
              </div>
            }
            <div className="content-hours">
              <HoursForm
                selectedDate={selectedDate}
                handleHour={handleHour}
                selectedHour={selectedTime}
                hoursList={availableTimes} />
            </div>

          </>
        }
      </div>

      <div className="page-container-button">
        <ButtonAccessibility
          variant="contained"
          fullWidth
          disabled={!selectedTime}
          onClick={() => {
            formik.setFieldValue('selectedDate', selectedDate)
            formik.setFieldValue('selectedHour', selectedTime)
            setTabs((prev) => prev + 1)
          }}
        >
          CONTINUAR
        </ButtonAccessibility>
      </div>
    </div>
  )
}